import { Head, Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'

export default function Register() {
  const form = useForm({ name: '', email: '', password: '', confirmPassword: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (form.data.password !== form.data.confirmPassword) {
      form.setError('confirmPassword', '两次输入的密码不一致')
      return
    }
    form.transform(({ name, email, password }) => ({ name, email, password }))
    form.post('/register')
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Head title="注册" />
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">注册新账户</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            或{' '}
            <Link href="/login" className="font-medium text-blue-600 hover:text-blue-500">
              登录已有账户
            </Link>
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={submit}>
          {Object.values(form.errors).length > 0 && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="text-sm text-red-700">{Object.values(form.errors)[0]}</div>
            </div>
          )}

          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only">姓名</label>
              <input
                id="name"
                type="text"
                autoComplete="name"
                required
                value={form.data.name}
                onChange={(e) => form.setData('name', e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="姓名"
              />
            </div>
            <div>
              <label htmlFor="email" className="sr-only">邮箱地址</label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={form.data.email}
                onChange={(e) => form.setData('email', e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="邮箱地址"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">密码</label>
              <input
                id="password"
                type="password"
                autoComplete="new-password"
                required
                value={form.data.password}
                onChange={(e) => form.setData('password', e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="密码"
              />
            </div>
            <div>
              <label htmlFor="confirm-password" className="sr-only">确认密码</label>
              <input
                id="confirm-password"
                type="password"
                autoComplete="new-password"
                required
                value={form.data.confirmPassword}
                onChange={(e) => form.setData('confirmPassword', e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="确认密码"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={form.processing}
            className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white ${
              form.processing ? 'bg-blue-400' : 'bg-blue-600 hover:bg-blue-700'
            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
          >
            {form.processing ? '注册中...' : '注册'}
          </button>
        </form>
      </div>
    </div>
  )
}
